import { render, staticRenderFns } from "./import-data-dialog.vue?vue&type=template&id=3c64bd60&scoped=true"
import script from "./import-data-dialog.vue?vue&type=script&lang=js"
export * from "./import-data-dialog.vue?vue&type=script&lang=js"
import style0 from "./import-data-dialog.vue?vue&type=style&index=0&id=3c64bd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c64bd60",
  null
  
)

export default component.exports